import Register from "../components/Register";
import Manager from "../components/Manager";
import ManagerCal from "../components/ManagerCal";
import Designer from "../components/Designer";
import Storage from "../components/Storage";
import Keeper from "../components/Keeper";
import Status from "../components/Status";
import Sewing from "../components/Sewing";
import Fabrik from "../components/Fabrik";
import Login from "../components/Login";
import Admin from "../components/Admin";
import Print from "../components/Print";
import HP from "../components/HP";
import Dashboard from "../components/Dashboard";
import DesignerPage from "../components/DesignerPage";
import DesignerPrint from "../components/DesignerPrint";
import ArhiveSearch from "../components/ArhiveSearch";

export const pagesArr = [
  { to: "designer", text: "Designer" },
  { to: "storage", text: "Storage" },
  { to: "keeper", text: "Keeper" },
  { to: "print", text: "Print" },
  { to: "manager", text: "Manager" },
  { to: "sewing", text: "Sewing" },
  { to: "hp", text: "HP Print" },
  { to: "dashboard", text: "Dashboard" },
  { to: "fabrik", text: "Fabrik" },
];

export const buttonsConfig = {
  adminboard: [{ to: "admin", text: "Admin" }],
  admin: [
    { to: "designer", text: "Designer" },
    { to: "manager", text: "Manager" },
    { to: "managercal", text: "Manager Calendar" },
    { to: "keeper", text: "Keeper" },
    { to: "/", text: "Print" },
    { to: "hp", text: "HP" },
    { to: "sewing", text: "Sewing" },
    { to: "dashboard", text: "Dashboard" },
    { to: "fabrik", text: "Fabrik" },
  ],

  director: [
    { to: "/", text: "Manager" },
    { to: "managercal", text: "Manager Calendar" },
    { to: "keeper", text: "Keeper" },
    { to: "sewing", text: "Sewing" },
    { to: "dashboard", text: "Dashboard" },
    { to: "fabrik", text: "Fabrik" },
  ],
  designer: [
    { to: "/", text: "My Orders" },
    { to: "/designer", text: "Designer" },
    { to: "designer_print", text: "Print" },
    { to: "dashboard", text: "Dashboard" },
  ],
  print: [
    { to: "/", text: "HP" },
    { to: "manager", text: "Manager" },
  ],
};
// DesigPage
export const routeItems = {
  admin: [
    { route: "/", tag: <Print /> },
    { route: "/designer_print", tag: <DesignerPrint /> },
    { route: "/hp", tag: <HP /> },
    { route: "/admin", tag: <Admin /> },
    { route: "/dashboard", tag: <Dashboard /> },
    { route: "/designer", tag: <Designer /> },
    { route: "/fabrik", tag: <Fabrik /> },
    { route: "/keeper", tag: <Keeper /> },
    { route: "/login", tag: <Login /> },
    { route: "/manager", tag: <Manager /> },
    { route: "/managercal", tag: <ManagerCal /> },
    { route: "/register", tag: <Register /> },
    { route: "/sewing", tag: <Sewing /> },
    { route: "/status", tag: <Status /> },
    { route: "/search", tag: <ArhiveSearch /> },
  ],
  director: [
    { route: "/", tag: <Manager /> },
    { route: "/dashboard", tag: <Dashboard /> },
    { route: "/keeper", tag: <Keeper /> },
    { route: "/login", tag: <Login /> },
    { route: "/manager", tag: <Manager /> },
    { route: "/managercal", tag: <ManagerCal /> },
    { route: "/register", tag: <Register /> },
    { route: "/sewing", tag: <Sewing /> },
    { route: "/fabrik", tag: <Fabrik /> },
    { route: "/search", tag: <ArhiveSearch /> },
  ],
  designer: [
    { route: "/", tag: <DesignerPage /> },
    { route: "/designer", tag: <Designer /> },
    { route: "/dashboard", tag: <Dashboard /> },
    { route: "/designer_print", tag: <DesignerPrint /> },
    { route: "/fabrik", tag: <Fabrik /> },
    { route: "/login", tag: <Login /> },
    { route: "/register", tag: <Register /> },
    { route: "/storage", tag: <Storage /> },
    { route: "/search", tag: <ArhiveSearch /> },
  ],
  manager: [
    { route: "/", tag: <Manager /> },
    { route: "/managercal", tag: <ManagerCal /> },
    { route: "/dashboard", tag: <Dashboard /> },
    { route: "/login", tag: <Login /> },
    { route: "/register", tag: <Register /> },
    { route: "/search", tag: <ArhiveSearch /> },
  ],
  keeper: [
    { route: "/", tag: <Keeper /> },
    { route: "/login", tag: <Login /> },
    { route: "/register", tag: <Register /> },
    { route: "/search", tag: <ArhiveSearch /> },
    { route: "/managercal", tag: <ManagerCal /> },
  ],
  print: [
    { route: "/", tag: <HP /> },
    { route: "/manager", tag: <Manager /> },
    { route: "/login", tag: <Login /> },
    { route: "/register", tag: <Register /> },
    { route: "/search", tag: <ArhiveSearch /> },
  ],
  sewing: [
    { route: "/", tag: <Sewing /> },
    { route: "/login", tag: <Login /> },
    { route: "/register", tag: <Register /> },
    { route: "/search", tag: <ArhiveSearch /> },
  ],
  guest: [
    { route: "/", tag: <Status /> },
    { route: "/login", tag: <Login /> },
    { route: "/register", tag: <Register /> },
  ],
  null: [
    { route: "/", tag: <Login /> },
    { route: "/register", tag: <Register /> },
  ],
};
